var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0125 0.887451H1.88745C1.2687 0.887451 0.762451 1.3937 0.762451 2.01245V8.76245C0.762451 9.3812 1.2687 9.88745 1.88745 9.88745H4.69995V10.45C4.69995 10.7593 4.95308 11.0125 5.26245 11.0125H8.63745C8.94683 11.0125 9.19995 10.7593 9.19995 10.45V9.88745H12.0125C12.6312 9.88745 13.1375 9.3812 13.1375 8.76245V2.01245C13.1375 1.3937 12.6312 0.887451 12.0125 0.887451ZM11.45 8.76245H2.44995C2.14058 8.76245 1.88745 8.50933 1.88745 8.19995V2.57495C1.88745 2.26558 2.14058 2.01245 2.44995 2.01245H11.45C11.7593 2.01245 12.0125 2.26558 12.0125 2.57495V8.19995C12.0125 8.50933 11.7593 8.76245 11.45 8.76245ZM10.325 3.69995H5.26245C4.95308 3.69995 4.69995 3.95308 4.69995 4.26245C4.69995 4.57183 4.95308 4.82495 5.26245 4.82495H10.325C10.6343 4.82495 10.8875 4.57183 10.8875 4.26245C10.8875 3.95308 10.6343 3.69995 10.325 3.69995ZM10.325 5.94995H5.26245C4.95308 5.94995 4.69995 6.20308 4.69995 6.51245C4.69995 6.82183 4.95308 7.07495 5.26245 7.07495H10.325C10.6343 7.07495 10.8875 6.82183 10.8875 6.51245C10.8875 6.20308 10.6343 5.94995 10.325 5.94995ZM4.13745 3.69995H3.01245V4.82495H4.13745V3.69995ZM4.13745 5.94995H3.01245V7.07495H4.13745V5.94995Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.32d119d4.svg";
export { ForwardRef as ReactComponent };